module.exports = __webpack_public_path__ + "static/shape-pattern1-d99df506f0cb8cf704bea5bc18b431e3.png";